'use client';

import { useTranslations } from 'next-intl';
import { useCallback, useMemo } from 'react';
import type { CommentsSort as SortKey } from '@/lib/api/comments';
import { useAuthSession } from '@/lib/hooks/useAuth';
import type { SelectOption } from '@/lib/types/select-option';
import { CommentsCheckbox } from './CommentsCheckbox';
import { useCommentsContext } from './CommentsContext';
import { CommentsSort } from './CommentsSort';

export const CommentsFilters = () => {
  const { sort, setSort, onlyHolders, setOnlyHolders, onlyMine, setOnlyMine, source } =
    useCommentsContext();
  const t = useTranslations(source.kind === 'event' ? 'eventComments' : 'comments');
  const { isAuthenticated } = useAuthSession();

  const sortOptions: SelectOption[] = useMemo(
    () => [
      { label: t('sort.newest'), value: 'createdAt:desc' },
      { label: t('sort.oldest'), value: 'createdAt:asc' },
    ],
    [t],
  );

  const handleChangeSort = useCallback((value: string) => setSort(value as SortKey), [setSort]);

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:gap-x-5">
      <CommentsSort options={sortOptions} value={sort} onChange={handleChangeSort} />
      {source.kind === 'event' && (
        <CommentsCheckbox
          label={t('filter.onlyHolders')}
          onChange={setOnlyHolders}
          checked={onlyHolders}
        />
      )}
      {isAuthenticated && (
        <CommentsCheckbox
          label={t('filter.myComments')}
          onChange={setOnlyMine}
          checked={onlyMine}
        />
      )}
    </div>
  );
};
